import React from 'react'

import styled from '@emotion/styled'

import { AlertOutlineIcon } from '@arcade/web/icons/react'

import { spacing } from '../../theme'

const Banner = styled.div`
  color: ${props => props.theme.colors.bannerTextError};
  background: ${props => props.theme.colors.bannerBackgroundError};
  border-radius: 1rem;
  padding: ${({ theme }) => theme.spacing.m};
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: ${spacing.m};
  row-gap: ${spacing.l};
  overflow-wrap: anywhere;
`
const AdditionalContent = styled.div`
  grid-column: 2 / -1;
`

const Content = styled.p`
  ${props => props.theme.typography.bodyDefault};
  color: inherit;
`

const ErrorBanner = ({
  value,
  children,
  ...rest
}: {
  value: string | string[]
  children?: React.ReactNode
  'data-testid'?: string
  style?: React.ComponentProps<typeof Banner>['style']
}) => {
  const errors = Array.isArray(value) ? value : [value]

  return (
    <Banner role="alert" {...rest}>
      {errors.map((error, index) => (
        <React.Fragment key={index}>
          <AlertOutlineIcon aria-hidden size={24} />
          <Content>{error}</Content>
        </React.Fragment>
      ))}
      {children && <AdditionalContent>{children}</AdditionalContent>}
    </Banner>
  )
}

export default ErrorBanner
